$(() => {
  const sidebar = $('.how-it-works-nav.desktop-nav');

  if (window.location.hash) {
    $(`a[href="${window.location.hash}"]`).click();
  }

  //sync desktop/mobile navs
  $('.how-it-works-nav a').click(function () {
    const nav = $(this).parent().parent();
    const href = $(this).attr('href');

    const otherNavClass = nav.hasClass('mobile-nav') ? 'desktop-nav' : 'mobile-nav';
    const otherNav = $(`.how-it-works-nav.${otherNavClass}`);

    otherNav.find('li').removeClass('active');
    otherNav.find(`a[href='${href}']`).parent().addClass('active');

  })

  sidebar.affix({
    offset: {
      top: function() {
        return this.top = sidebar.offset().top
      },
      bottom: function() {
        const a = $('section.copyright').outerHeight();
        const b = $('footer.footer').outerHeight();

        return a + b + 20;
      }
    }
  });
});
